import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-12">
                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                <div className="col-md-12">
                    <div className="about-desc">
                    <span className="heading-meta">About Me</span>
                    <h2 className="colorlib-heading">Who Am I?</h2>
                    <p>An Enthusiastic and result driven Full Stack developer currently pursuing Masters in Information Systems at Northeastern University.<br>
                    </br> <br></br>My tenure at BNP Paribas India Solutions of 2 years as a Software Analyst gave me an opportunity to enhance my programming skills in Java and Python, using which I developed applications and Automated test suites for trading applications. I also attained deep insights of the Financial markets and collaborated in the migration of Electronic market access projects. Putting my leadership skills to use, I successfully lead a project that focused on testing and enhancement of Trading algorithms, applications and order routing system.

                    <br></br><br>
                    </br>In the recent years I have been engaged in developing web applications and software using my knowledge in Full Stack development and looking forward to design applications helpful to both businesses and the community. An avid tech-savvy individual, always seeking to harness knowledge and grow my learning scope in the field of Technology. Aspire to work as a full stack developer with a company in a collaborative environment that offers a greater challenge and opportunity to glean experiences by increasing network and fine-tune the knowledge.</p>
                    
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
        <section className="colorlib-about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">What I do?</span>
                <h2 className="colorlib-heading">Here are some of my expertise</h2>
            </div>
            </div>
            <div className="row row-pt-md">
            <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                <span className="icon">
                    <i className="icon-device-laptop" />
                </span>
                <div className="desc">
                    <h3>Web Design and Development </h3>
    
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-2">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Software Development</h3>
                
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-6">
                <span className="icon">
                    <i className="icon-globe" />
                </span>
                <div className="desc">
                    <h3>Big Data Engineering</h3>
                
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-4">
                <span className="icon">
                    <i className="icon-cloud3" />
                </span>
                <div className="desc">
                    <h3>Cloud Computing</h3>
                
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                <span className="icon">
                    <i className="icon-layers2" />
                </span>
                <div className="desc">
                    <h3>Data Structures & Algorithms</h3>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Data Science with Python</h3>
                
                </div>
                </div>
            </div>
         
            {/*
            <div className="col-md-4 text-center animate-box">
                <div className="services color-2">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Dev Ops</h3>
                    <p>Jenkins , Kubernetes , Docker </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-4">
                <span className="icon">
                    <i className="icon-layers2" />
                </span>
                <div className="desc">
                    <h3>Graphic Design</h3>
                    <p>My friend knows .. P</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-6">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Digital Marketing</h3>
                    <p>I use Instagram eight hours a day :) </p>
                </div>
                </div>
            </div>
            */}
            </div>
        </div>
        </section>
      </div>
    )
  }
}
